/* unplugin-vue-components disabled */import { render } from "./external-modal.vue?vue&type=template&id=cfb2efd2&scoped=true"
import script from "./external-modal.vue?vue&type=script&lang=js"
export * from "./external-modal.vue?vue&type=script&lang=js"

import "./external-modal.vue?vue&type=style&index=0&id=cfb2efd2&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfb2efd2"],['__file',"src/components/md-content/external-modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cfb2efd2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cfb2efd2', __exports__)) {
    api.reload('cfb2efd2', __exports__)
  }
  
  module.hot.accept("./external-modal.vue?vue&type=template&id=cfb2efd2&scoped=true", () => {
    api.rerender('cfb2efd2', render)
  })

}


export default __exports__